import * as DAOUtils from "../utils/DAOUtils";
import API from "@/factories/api.factory";

export async function getPills(searchQuery, listId) {
  return await DAOUtils.get(`/pills?query=${searchQuery}&worklistid=${listId}`, {
    mock: "heroku"
  });
}

export async function addPill(listId, pill) {
  return await DAOUtils.post(`/pills/${listId}`, pill, {
    mock: "heroku"
  });
}

export async function uploadXlsFile(listId, file) {
  return await DAOUtils.post(`/worklists/${listId}/upload`, file, {
    mock: "heroku",
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

export function getUploadXlsFileStatus(listId, requestId) {
  return API.get(`/worklists/${listId}/upload/${requestId}`, {
    mock: "heroku"
  });
}
